import { createColumnHelper } from '@tanstack/react-table';

import { Employee } from 'types/user';
import { convertUTCToLocal } from 'utils/dateUtils';

const col = createColumnHelper<Employee>();

/**
 * SuperAdmins and WashHubAdmins render the identical 8 columns; only the
 * underlying query differs (see EmployeesTable). getWashHubByID resolves a
 * washHub id against the Redux-loaded list, so it's passed in rather than
 * looked up inside a plain accessor function.
 */
export const buildEmployeeColumns = (
  getWashHubByID: (washId?: string) => string,
) => [
  col.accessor(
    (employee) => `${employee?.fname || ''} ${employee?.lname || '-'}`,
    {
      id: 'fullName',
      header: 'Full Name',
      minSize: 150,
      size: 200,
    },
  ),
  col.accessor((employee) => employee?.permissions?.[0]?.role || '-', {
    id: 'role',
    header: 'Role',
    minSize: 100,
    size: 120,
  }),
  col.accessor((employee) => employee?.email || '-', {
    id: 'email',
    header: 'Email',
    minSize: 200,
    size: 300,
  }),
  col.accessor((employee) => employee?.phone || '-', {
    id: 'phone',
    header: 'Phone Number',
    minSize: 120,
    size: 120,
  }),
  col.accessor((employee) => employee?.status || '-', {
    id: 'status',
    header: 'Status',
    minSize: 90,
    size: 100,
  }),
  col.accessor(
    (employee) => getWashHubByID(employee?.permissions?.[0]?.washHub),
    {
      id: 'washHub',
      header: 'Wash Hub',
      minSize: 150,
      size: 170,
    },
  ),
  col.accessor((employee) => convertUTCToLocal(employee?.createdAt, true), {
    id: 'createdAt',
    header: 'Date Hired',
    minSize: 110,
    size: 150,
  }),
  col.accessor(() => ' - ', {
    id: 'deliveries',
    header: 'Deliveries',
    minSize: 90,
    size: 100,
  }),
];
